/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AvatarWrapper/view.blocks to change it.
import Avatar from 'DesignSystem/Avatar/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function AvatarWrapper({
  children,
  viewPath = "/DesignSystem/AvatarWrapper",
  cursor,
  profile_url,
  initials,
  size,
  backgroundColor,
  borderTopLeftRadius,
  borderTopRightRadius,
  borderBottomLeftRadius,
  borderBottomRightRadius,
  marginTop,
  marginBottom,
  marginRight,
  marginLeft,
  onClick,
  height,
  width
  
}) {
  return (<React.Fragment
>
<Avatar
  viewPath={`${viewPath}/Avatar`}
 cursor={cursor}
 profile_url={profile_url}
 initials={initials}
 size={size}
 backgroundColor={backgroundColor}
 borderTopLeftRadius={borderTopLeftRadius}
 borderTopRightRadius={borderTopRightRadius}
 borderBottomLeftRadius={borderBottomLeftRadius}
 borderBottomRightRadius={borderBottomRightRadius}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginRight={marginRight}
 marginLeft={marginLeft}
 onClick={onClick}
 height={height}
 width={width}
/>
{children}
</React.Fragment>)
}